import axios from 'axios';
import { from } from 'rxjs';

export const getProviders = () => {
  const request = axios.get('/freight/provider').then((r) => r.data);
  return from(request);
};

export const getSellerProviders = () => {
  const request = axios.get('/freight/seller-provider').then((r) => r.data);
  return from(request);
};

export const disconnectProvider = (sellerFreightProviderId: number) => {
  const request = axios.delete(`/freight/disconnect/${sellerFreightProviderId}`).then((r) => r.data);
  return from(request);
};
